import { ToastsManager } from 'ng6-toastr';
import { Injectable } from '@angular/core';

@Injectable()
export class ToastrService {
    constructor(public toastr: ToastsManager) { }

    // Success Type
    typeSuccess(value: string) {
        this.toastr.success(value, 'Success!', { dismiss: 'click', toastLife: 5000, showCloseButton: true });
    }

    // Success Type
    typeInfo(value: string, title: string) {
        this.toastr.info(value, title, { dismiss: 'click', toastLife: 5000, showCloseButton: true });
    }

    // Success Type
    typeWarning() {
        this.toastr.warning('My name is Inigo Montoya. You killed my father, prepare to die!');
    }

    // Success Type
    typeError(value) {
        this.toastr.error(value, 'Error !', { dismiss: 'click', showCloseButton: true });
    }

    // Custom Type
    typeCustom() {
        this.toastr.custom('<span style="color: red">Message in red.</span>', null, { enableHTML: true });
    }

    // Timeout
    timeout() {
        this.toastr.error('I do not think that word means what you think it means.', 'Timeout!', { "toastLife": 5000 });
    }

    //Dismiss toastr on Click
    dismissToastOnClick() {
        this.toastr.info('We do have the Kapua suite available.', 'Turtle Bay Resort', { dismiss: 'click' });
    }
    // Dismiss Toast controlled code
    dismissToastControlled() {
        this.toastr.success('You are awesome!', 'Success!', { dismiss: 'controlled' })
            .then(toast => {
                setTimeout(() => {
                    this.toastr.dismissToast(toast);
                }, 10000);
            });
    }
    // Remove current toasts using animation
    clearToast() {
        this.toastr.clearAllToasts()
    }

    // Show close button
    showCloseButton() {
        this.toastr.info('Have fun storming the castle!', 'Miracle Max Says', { showCloseButton: true });
    }
    // Enable  HTML
    enableHtml() {
        this.toastr.info('<i>Have fun <b>storming</b> the castle!</i>', 'Miracle Max Says', { enableHTML: true });
    }
    // Title Class
    titleClass() {
        this.toastr.info('Have fun storming the castle!', 'Miracle Max Says', { titleClass: 'h3' });
    }
    // Message Class
    messageClass() {
        this.toastr.info('Have fun storming the castle!', 'Miracle Max Says', { messageClass: 'text-uppercase' });
    }

}